import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Reset } from "../../../store/async-actions/digitalmarketing/header";
import { Col, Row } from "react-bootstrap";
import CountUp from "react-countup/build/CountUp";
import {
  AudienceCount,
  DashCount,
  SocialAudienceCount,
} from "./Utils/TableHeadlist";
import LeadChart from "./LeadChart";
import Enquiries from "./Enquiries";
import DashboardCount from "./DashboardCount";
import SocialAnalyticsCount from "./SocialAnalyticsCount";
import PermissionCheck from "../../../Component/PermissionCheck";
import { SidebarData } from "../../../Layout/DigitalMarketing/SidebarData";
import { useNavigate } from "react-router-dom";
import SocialMediaCount from "./socialmedia-analytics/SocialMediaCount";
import ChartBox from "./component/ChartBox";
import Chart from "./component/Chart";
import {
  useGetDashboardTotalCountQuery,
  useGetDashboardTotalleadQuery,
} from "../../../Service/dashboard";
import Dropdown from "../../../Component/DigitalMarketing/Forms/Dropdown";
import { useGetTreatmentsQuery } from "../../../Service/treatments";
import SocialMediaPerformance from "./SocialMediaPerformance";
import RevenueRate from "./RevenueRate";
import PatientCount from "./PatientCount";
import OverallPerformance from "./OverallPerformance";
import ConsultantSummary from "./ConsultantSummary";
import AppointementsSummary from "./AppointementsSummary";

function Dashboard() {
  const Customer = useSelector((state: any) => state.dashboard);
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const [service, setService] = useState({});
  const { data: dashboardLeadData }: any = useGetDashboardTotalleadQuery(
    service,
    {
      refetchOnMountOrArgChange: true,
    }
  );
  const [pagination, setpagination] = useState(1);

  const pagi = {
    pageNo: pagination,
  };
  const { data: TreatmentResponse, refetch } = useGetTreatmentsQuery(pagi, {
    refetchOnMountOrArgChange: true,
  });
  const { data }: any = useGetDashboardTotalCountQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  useEffect(() => {}, [pagination]);
  let List = {
    Created: data?.Created,
    not_interested: data?.not_interested,
    in_progress: data?.in_progress,
    not_answered: data?.not_answered,
  };
  let dashboardCountList = [];
  if (data) {
    const totalCountValue = Object.values(List);
    dashboardCountList = DashCount.map((item, index) => {
      item.list = totalCountValue[index];
      return item;
    });
  }
  useEffect(() => {
    dispatch(Reset());
  }, [dispatch]);
  useEffect(() => {
    if (!PermissionCheck("dashboard", "view")) {
      for (let i = 0; i < SidebarData.length; i++) {
        const a = SidebarData[i];
        if (PermissionCheck(a.name, "view")) {
          // console.log("a.path",a.path);
          navigate(`/${a.path}`);
          break;
        }
      }
      return;
    }
  }, []);
  const onHandleChange = (event) => {
    const { name, value } = event.target;
    setService((prevState) => ({ ...prevState, [name]: value }));
  };
  // console.log(service);
  useEffect(() => {
    if (TreatmentResponse?.length > 0) {
      setService((prevState) => ({
        ...prevState,
        source: TreatmentResponse?.[0]?.treatment_type_name,
      }));
    }
  }, [TreatmentResponse]);
  return (
    <React.Fragment>
      {/* <MimoCount CountList={TrendsCount} />  */}
      <Row className="mt-3 mb-3">
        <Col md={12} lg={6}>
          <div className="cards mb-2" style={{ minHeight: "370px" }}>
            <LeadChart list={data} />
          </div>
        </Col>
        {/* <Col md={12} lg={12} xl={6}>
          <div className="cards mb-2" style={{ minHeight: "370px" }}>
            <DashboardCount CountList={DashCount} />
          </div>
        </Col>
        <Col md={12} lg={12} xl={6}>
          <div className="cards mb-2" style={{ minHeight: "370px" }}>
            <SocialMediaPerformance/>
          </div>
        </Col> */}
        {/* <Col md={6} className="mb-4">
          {/* <div className="cards"> */}
          {/* <ChartBox
            element={<Chart list={dashboardLeadData?.serviceChoosen} />}
            prevMonth={dashboardLeadData?.preServiceMonthTotal}
            thisMonth={dashboardLeadData?.thisServiceMonthTotal}
            title="Service based lead count comparison"
            legend={true}
            filter={
              <div style={{ width: "100px" }}>
                <Dropdown
                  option={TreatmentResponse}
                  ids="treatment_type_name"
                  {...service}
                  defaults="Choose Source..."
                  list_name="treatment_type_name"
                  key_name="source"
                  handleChange={onHandleChange}
                  noDefault={true}
                />
              </div>
            }
          /> */}
          {/* <h3 className="f-20 fw-600 mb-3">Social Analytics </h3>
            <SocialAnalyticsCount CountList={SocialAudienceCount} /> */}
          {/* </div> */}
        {/* </Col>
        <Col md={6} className="mb-4">
          {/* <Enquiries /> */}
          {/* <ChartBox
            element={<Chart list={dashboardLeadData?.TotalLeadBasedCount} />}
            prevMonth={dashboardLeadData?.preMonthTotal}
            thisMonth={dashboardLeadData?.thisMonthTotal}
            title="Total lead count comparison"
            legend={true}
          /> */}
        {/* </Col>  */}
        <Col md={12} lg={12} xl={6}>
          <div className="cards mb-2" style={{ minHeight: "370px" }}>
            <RevenueRate/>
          </div>
        </Col>
        <Col md={12} lg={12} xl={6}>
          <div className="cards mb-2" style={{ minHeight: "370px" }}>
            <PatientCount/>
          </div>
        </Col>
        {/* <Col md={12} lg={12} xl={6}>
          <div className="cards mb-2" style={{ minHeight: "370px" }}>
            <OverallPerformance/>
          </div>
        </Col> */}
        <Col md={12} lg={6}>
          <div className="cards mb-2" style={{ minHeight: "205px" }}>
            <AppointementsSummary/>
          </div>
        </Col>
        <Col md={12} lg={6}>
          <div className="cards mb-2" style={{ minHeight: "205px" }}>
            <ConsultantSummary/>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
}

export default React.memo(Dashboard);
